var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { action, makeObservable, observable } from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import { Validation as WebSiteValidation } from '../components/validation/website-validation';
import { Validation as OwnerValidation } from '../components/validation/owner-validation';
import { Validation as ProcessingValidation } from '../components/validation/processing-validation';
import ApplicationFormApi from '../api/application-form-api';
import OptionsApi from '../../shared/options-api';
import { Initialize } from '../components/constants/initialize';
var ApplicationFormStore = /** @class */ (function () {
    function ApplicationFormStore() {
        Object.defineProperty(this, "applicationFormApi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new ApplicationFormApi()
        });
        Object.defineProperty(this, "optionsApi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new OptionsApi()
        });
        Object.defineProperty(this, "init", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Initialize()
        });
        Object.defineProperty(this, "cardTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "countries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "leadId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "currentFormWizard", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                id: uuidv4(),
                companyInfo: this.init.emptyCompany,
                websites: [
                    this.init.emptyWebsite
                ],
                owners: [
                    this.init.emptyOwner
                ],
                processing: this.init.emptyProcessor,
                integration: this.init.emptyIntergation
            }
        });
        Object.defineProperty(this, "isAdminMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isSubmitted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "leadApplicationFormId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "companyRequiredFieldsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 24
        });
        Object.defineProperty(this, "companyErrorsFieldsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "websitesErrorsFieldsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "ownersErrorsFieldsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "processingErrorsFieldsCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        makeObservable(this);
        window.$applicationFormStore = this;
        this.getCardTypes().then(function () { });
        this.getCountries().then(function () { });
    }
    Object.defineProperty(ApplicationFormStore.prototype, "updateCompanyFieldsInvalid", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (errors) {
            this.companyErrorsFieldsCount = errors;
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "updateWebsitesFieldsInvalid", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (errors) {
            this.websitesErrorsFieldsCount = errors;
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "updateOwnersFiledsInvalid", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (errors) {
            this.ownersErrorsFieldsCount = errors;
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "updateProcessingFieldsInvalid", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (errors) {
            this.processingErrorsFieldsCount = errors;
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "setValidation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isvalid) {
            this.isValid = isvalid;
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "updateCompanyInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (companyInfo) {
            this.currentFormWizard.companyInfo = companyInfo;
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "updateWebsites", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (websites) {
            this.currentFormWizard.websites = websites;
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "updateOwners", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (owners) {
            this.currentFormWizard.owners = owners;
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "updateProcessingInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (processingInfo) {
            this.currentFormWizard.processing = processingInfo;
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "isDisabledForm", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.isAdminMode)
                return false;
            return this.isSubmitted;
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "getCardTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var response, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.optionsApi.getAllCreditCards()];
                        case 1:
                            response = _a.sent();
                            this.cardTypes = response.data;
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            console.log('Connection error');
                            console.log(e_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "getCountries", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var response, e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.optionsApi.getCountries()];
                        case 1:
                            response = _a.sent();
                            this.countries = response.data;
                            return [3 /*break*/, 3];
                        case 2:
                            e_2 = _a.sent();
                            console.log('Connection error');
                            console.log(e_2);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "getFormWizard", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var response, form, e_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 4, , 5]);
                            return [4 /*yield*/, this.applicationFormApi.getApplicationForm(this.leadId)];
                        case 1:
                            response = _a.sent();
                            if (!(response !== null)) return [3 /*break*/, 3];
                            if (response.applicationFormID !== 0) {
                                form = JSON.parse(response.formJson);
                                this.isSubmitted = response.isSubmitted;
                                this.leadApplicationFormId = response.crmLeadId;
                                this.currentFormWizard = form;
                            }
                            return [4 /*yield*/, this.validateForm(this.currentFormWizard)];
                        case 2:
                            _a.sent();
                            this.isLoaded = true;
                            _a.label = 3;
                        case 3: return [3 /*break*/, 5];
                        case 4:
                            e_3 = _a.sent();
                            console.log('Connection error');
                            console.log(e_3);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "validateForm", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (form) {
            // NOTE
            // Company info is validated after form is loaded that's why is not necessary to run validation once again
            var _this = this;
            // validate websites
            var webSiteValidation = new WebSiteValidation();
            var websitesErrorsCount = 0;
            form.websites.forEach(function (item) {
                webSiteValidation.schema.validate(item, { abortEarly: false })
                    .then(function () {
                })
                    .catch(function (err) {
                    websitesErrorsCount += err.inner.length;
                    _this.updateWebsitesFieldsInvalid(websitesErrorsCount);
                });
            });
            // validate owners 
            var ownerValidation = new OwnerValidation();
            var ownerErrorsCount = 0;
            form.owners.forEach(function (item) {
                ownerValidation.schema.validate(item, { abortEarly: false })
                    .then(function () {
                })
                    .catch(function (err) {
                    ownerErrorsCount += err.inner.length;
                    _this.updateOwnersFiledsInvalid(ownerErrorsCount);
                });
            });
            // validate processing
            var processingValidation = new ProcessingValidation();
            var processingErrorsCount = 0;
            processingValidation.schema.validate(form.processing, { abortEarly: false })
                .then(function () { })
                .catch(function (err) {
                processingErrorsCount = err.inner.length;
                _this.updateProcessingFieldsInvalid(processingErrorsCount);
            });
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "initForm", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (leadId, isAdmin) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.leadId = leadId;
                            if (!!isAdmin) {
                                console.log('IS ADMIN:' + isAdmin);
                                this.isAdminMode = isAdmin;
                            }
                            return [4 /*yield*/, this.getFormWizard()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "submit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.applicationFormApi.submit(this.leadId, this.currentFormWizard).then(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    this.isSubmitted = true;
                                    return [2 /*return*/];
                                });
                            }); })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(ApplicationFormStore.prototype, "save", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.applicationFormApi.save(this.leadId, this.currentFormWizard)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "cardTypes", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "countries", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "leadId", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "currentFormWizard", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "isAdminMode", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "isSubmitted", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "isValid", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "leadApplicationFormId", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "isLoaded", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "companyRequiredFieldsCount", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "companyErrorsFieldsCount", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "websitesErrorsFieldsCount", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "ownersErrorsFieldsCount", void 0);
    __decorate([
        observable
    ], ApplicationFormStore.prototype, "processingErrorsFieldsCount", void 0);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "updateCompanyFieldsInvalid", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "updateWebsitesFieldsInvalid", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "updateOwnersFiledsInvalid", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "updateProcessingFieldsInvalid", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "setValidation", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "updateCompanyInfo", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "updateWebsites", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "updateOwners", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "updateProcessingInfo", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "isDisabledForm", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "getCardTypes", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "getCountries", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "getFormWizard", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "validateForm", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "initForm", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "submit", null);
    __decorate([
        action
    ], ApplicationFormStore.prototype, "save", null);
    return ApplicationFormStore;
}());
export default ApplicationFormStore;
